import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './system/lang/lang.js';
import './assets/styles/global.scss';
import { captureToken } from './system/auth/authenticate';
import { getGlobalSetting, getMemberInfo, setLanguage } from './system/request/api/api';
import { handleError } from './system/request/handleRes';
import { money, signed } from './utils/format';
import config from './system/request/config';

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();

captureToken();

new Vue({
  router,
  i18n,
  data() {
    return {
      isLoading: false,
      userInfo: {},
      globalSetting: {},
      toast: { show: false, type: 'success', msg: '' },
    };
  },
  methods: {
    money,
    signed,
    getInfo() {
      return getMemberInfo()
        .then(res => {
          if (res.data && res.data.data) this.userInfo = res.data.data;
        })
        .catch(err => console.log(err));
    },
    getGlobalSetting() {
      return getGlobalSetting()
        .then(res => {
          this.globalSetting = (res.data.data && res.data.data.system) || {};
        })
        .catch(err => console.log(err));
    },
    makeToast(type, msg) {
      this.toast = { show: true, type, msg };
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => { this.toast.show = false; }, 3000);
    },
    toastError(error) {
      this.makeToast('danger', this.$t(handleError(error)));
    },
    changeLan(lan) {
      localStorage.setItem('lan', lan);
      this.$i18n.locale = lan;
      const formData = new FormData();
      formData.append('language', lan);
      setLanguage(formData).catch(() => {});
    },
    backToMember() {
      window.location.href = config.memberUrl;
    },
  },
  created() {
    this.getGlobalSetting();
    this.getInfo();
  },
  render: h => h(App),
}).$mount('#app');
